var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity_score",
    "data-name": "activity score",
    transform: "translate(-1046 -458)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2229",
    "data-name": "Rectangle 2229",
    width: 64,
    height: 64,
    transform: "translate(1046 458)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "running",
    transform: "translate(1052 469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M48.677,23.9l-8.072-.577-5.335-8.887L32.6,9.989V8.757a2.422,2.422,0,0,0-3.3-2.26l-7.67,2.959.58-1.945a3.615,3.615,0,0,0-1.784-4.166L14.414.111a.932.932,0,0,0-1.239.341L4.347,14.589l-.186-.108a.931.931,0,0,0-1.271.344l-.016.029L.11,20.057a.932.932,0,0,0,.373,1.252L34.1,39.939a.932.932,0,0,0,.451.116H48.44a5.594,5.594,0,0,0,5.589-5.589V29.649A5.782,5.782,0,0,0,48.677,23.9Zm-10.019-.2-1.064.355L29.26,13.22,31.4,11.611ZM14.315,2.172l5.236,2.81a1.755,1.755,0,0,1,.874,2.011l-.77,2.594L14.309,6.381,12.457,5.27ZM8.8,11.063l.477-.745L12.342,12.6a5.336,5.336,0,0,1,2.077,5.031L14.3,20.32l-8.325-4.8Zm39.64,27.13H34.786L2.182,20.121l1.883-3.54L34.933,34.342a.928.928,0,0,0,.466.124H52.166A3.726,3.726,0,0,1,48.44,38.193ZM52.166,32.6H35.647l-6.389-3.678,2.148-2.19a.932.932,0,0,0-1.33-1.3l-2.485,2.534-3.54-2.04,3.55-2.84a.932.932,0,0,0-1.164-1.455l-4.12,3.3-3.033-1.744,4.6-3.835a.932.932,0,1,0-1.192-1.433l-5.131,4.277-1.44-.829.151-3.576A7.154,7.154,0,0,0,13.453,11.1l-3.174-2.36,1.2-1.883L19.724,11.8a.911.911,0,0,0,.361.117c.022,0,.042.007.064.009s.036.007.054.007a.926.926,0,0,0,.337-.062l9.436-3.639a.56.56,0,0,1,.762.526V9.784L27.385,12.3a.931.931,0,0,0-.185,1.3l.006.008,9.315,12.11a.927.927,0,0,0,1.032.316l2.618-.873,8.371.6a3.912,3.912,0,0,1,3.623,3.886Zm0,0",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M5.589,256H.932a.932.932,0,0,0,0,1.863H5.589a.932.932,0,0,0,0-1.863Zm0,0",
    transform: "translate(0 -228.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M0,309.9a.932.932,0,0,0,.932.932h12.11a.932.932,0,0,0,0-1.863H.932A.932.932,0,0,0,0,309.9Zm0,0",
    transform: "translate(0 -276.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M23.288,361.934H.932a.931.931,0,1,0,0,1.863H23.288a.931.931,0,0,0,0-1.863Zm0,0",
    transform: "translate(0 -323.741)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityScore);
export default __webpack_public_path__ + "static/media/activity-score.ac87a9ecbefafd3d89e1bea3c33182cf.svg";
export { ForwardRef as ReactComponent };